module.exports = __webpack_public_path__ + "media/images/product/m_e-f0f8fbebf89e1f40c3db5b73de19c318.png";